export const FEED_CACHE_NAME = 'growwgram_feed';

export const CACHED_TIME_HEADER = 'cached-time';

// Duration in seconds for which the response should be cached
export const CACHE_DURATION = process.env.REACT_APP_CACHE_DURATION || 120;
